export default function CBooleans() {
  return <h2>C Booleans</h2>;
}
